// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".myflex p {\n  font-size: 1.5rem;\n  padding: 30px;\n}", "",{"version":3,"sources":["webpack://./src/app/shared/mission/mission.component.scss"],"names":[],"mappings":"AACA;EACI,iBAAA;EACA,aAAA;AAAJ","sourcesContent":["\r\n.myflex p {\r\n    font-size: 1.5rem;\r\n    padding: 30px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
